// extracted by mini-css-extract-plugin
export default {"container":"DocumentStorePage_container__0EBLP","title":"DocumentStorePage_title__ouaGU"};